module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_9005.fc78d6cc.png";